import axios from 'axios'
import { REACT_APP_API } from '../../config'
import { generateErrorObject } from 'common/utils/generateErrorObject'

export async function login(body) {
  try {
    const response = await axios.post(`${REACT_APP_API}/auth/login`, body)

    return response?.data?.data
  } catch (error) {
    throw generateErrorObject(error)
  }
}
